import React from 'react';
import { Button } from 'react-bootstrap';
import './ConfigStickyActionBar.css';

/**
 * Sticky Save/Cancel bar with optional unsaved-changes indicator.
 */
const ConfigStickyActionBar = ({
  onCancel,
  onSave,
  isDirty = false,
  isSaving = false,
  saveDisabled = false,
  cancelLabel = 'Cancel',
  saveLabel = 'Save',
  title,
  subtitle,
}) => (
  <div className="config-sticky-action-bar">
    <div className="config-sticky-action-bar__left">
      {title && <div className="config-sticky-action-bar__title">{title}</div>}
      {subtitle && <div className="config-sticky-action-bar__subtitle text-muted">{subtitle}</div>}
      {isDirty ? (
        <span className="config-sticky-action-bar__dirty-pill">Unsaved changes</span>
      ) : (
        <span className="config-sticky-action-bar__dirty-pill is-hidden" aria-hidden="true">
          Unsaved changes
        </span>
      )}
    </div>
    <div className="config-sticky-action-bar__actions">
      <Button variant="secondary" onClick={onCancel} disabled={isSaving}>
        {cancelLabel}
      </Button>
      <Button
        variant="primary"
        onClick={onSave}
        disabled={saveDisabled || isSaving || !isDirty}
        className="save-button"
      >
        {isSaving ? 'Saving…' : saveLabel}
      </Button>
    </div>
  </div>
);

export default ConfigStickyActionBar;
